import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { changelogData } from './changelog';

import * as Sentry from '@sentry/angular';
if (environment.production) {
  enableProdMode();

  Sentry.init({
    release: `tracking-angular@${changelogData.length ? changelogData[0].version : '0.0.0'}`,
    dsn: environment.sentryDsn,
    integrations: [
      // Registers and configures the Tracing integration,
      // which automatically instruments your application to monitor its
      // performance, including custom Angular routing instrumentation
      Sentry.browserTracingIntegration({
        // tracingOrigins: ['localhost', 'https://yourserver.io/api'],
      }),
    ],
    // Do not sent 5xx and 4xx errors to Sentry
    beforeSend(event, hint) {
      const error = hint.originalException;
      const errorMessages = ['Http failure response', 'ChunkLoadError', '<!DOCTYPE html>'];
      const errorNames = ['HttpErrorResponse', 'ChunkLoadError'];
      const errorTokens = [
        "expected expression, got '<'",
        "Unexpected token '<'",
        'dynamically imported module',
        'Importing a module',
        '<!DOCTYPE html>',
      ];

      if (typeof error === 'string' && errorMessages.some((msg) => error.includes(msg))) {
        return null;
      }
      if (error instanceof Error) {
        if (errorNames.includes(error.name) || errorTokens.some((token) => error.message?.includes(token))) {
          return null;
        }
      }
      return event;
    },

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0,

    // Sentry automatically creates environments
    // when it receives an event with the environment tag.
    environment: environment.name,
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
